import axios from "axios";
import Config from "src/config";

const v2_actionLogsAutomacoes = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/automacoes/logs${querys}`,
    });
};

export default v2_actionLogsAutomacoes;
